(function () {
  'use strict';

  if (!customElements.get('product-card')) {
    customElements.define('product-card', class extends HTMLElement {});
  }

  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menuPanel = document.querySelector('[data-menu-panel]');
  const menuOverlay = document.querySelector('[data-menu-overlay]');

  function setMobileMenu(open) {
    if (!menuToggle || !menuPanel) return;
    menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      menuPanel.setAttribute('data-open', 'true');
      if (menuOverlay) {
        menuOverlay.hidden = false;
        menuOverlay.setAttribute('data-open', 'true');
      }
      document.body.classList.add('has-mobile-menu');
    } else {
      menuPanel.removeAttribute('data-open');
      if (menuOverlay) {
        menuOverlay.removeAttribute('data-open');
        menuOverlay.hidden = true;
      }
      document.body.classList.remove('has-mobile-menu');
    }
  }

  if (menuToggle) {
    menuToggle.addEventListener('click', function () {
      const open = menuToggle.getAttribute('aria-expanded') !== 'true';
      setMobileMenu(open);
    });
  }
  if (menuOverlay) {
    menuOverlay.addEventListener('click', function () {
      setMobileMenu(false);
    });
  }
  window.addEventListener('resize', function () {
    if (window.innerWidth >= 990 && menuToggle && menuToggle.getAttribute('aria-expanded') === 'true') {
      setMobileMenu(false);
    }
    initHeaderProductCarousels();
  });

  document.addEventListener('click', function (event) {
    const toggle = event.target.closest('.site-header__nav-toggle');
    const items = document.querySelectorAll('.site-header__nav-item.has-dropdown');

    if (toggle) {
      const item = toggle.closest('.site-header__nav-item');
      const isOpen = item.getAttribute('data-open') === 'true';
      items.forEach((el) => {
        el.removeAttribute('data-open');
        const btn = el.querySelector('.site-header__nav-toggle');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.setAttribute('data-open', 'true');
        toggle.setAttribute('aria-expanded', 'true');
      } else {
        toggle.blur();
      }
      event.preventDefault();
      return;
    }

    if (!event.target.closest('.site-header__nav-item.has-dropdown')) {
      items.forEach((el) => {
        el.removeAttribute('data-open');
        const btn = el.querySelector('.site-header__nav-toggle');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }
  });

  function initHeaderProductCarousels() {
    const carouselEnabled = window.matchMedia('(min-width: 990px)').matches;

    document.querySelectorAll('[data-header-product-carousel]').forEach((carousel) => {
      const items = Array.from(carousel.querySelectorAll('[data-carousel-item]'));
      const pageSize = parseInt(carousel.getAttribute('data-page-size'), 10) || 6;
      const totalPages = Math.ceil(items.length / pageSize);
      const dots = carousel.querySelector('[data-carousel-dots]');
      const controls = carousel.querySelector('[data-carousel-controls]');

      if (!carouselEnabled) {
        initHeaderProductMobileLoadMore(carousel, items);
        if (controls) controls.hidden = true;
        return;
      }

      if (carousel.dataset.initialized !== 'true') {
        carousel.dataset.initialized = 'true';
        carousel.dataset.page = '0';
      }

      if (dots) {
        dots.innerHTML = '';
        for (let i = 0; i < totalPages; i += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'site-header__product-carousel-dot';
          dot.setAttribute('data-carousel-dot', '');
          dot.setAttribute('data-carousel-page', String(i));
          dot.setAttribute('aria-label', 'Halaman produk ' + (i + 1));
          dots.appendChild(dot);
        }
      }

      if (totalPages <= 1) {
        items.forEach((item) => { item.hidden = false; });
        if (controls) controls.hidden = true;
        return;
      }

      carousel.dataset.mobileVisible = '3';
      const loadMore = carousel.querySelector('[data-carousel-load-more]');
      if (loadMore) loadMore.hidden = true;
      if (controls) controls.hidden = false;
      renderHeaderProductCarousel(carousel);
    });
  }

  function initHeaderProductMobileLoadMore(carousel, items) {
    const loadMore = carousel.querySelector('[data-carousel-load-more]');
    const initialCount = 3;
    let visibleCount = parseInt(carousel.dataset.mobileVisible || String(initialCount), 10);

    if (Number.isNaN(visibleCount)) visibleCount = initialCount;
    visibleCount = Math.max(initialCount, Math.min(visibleCount, items.length));
    carousel.dataset.mobileVisible = String(visibleCount);

    items.forEach((item, index) => {
      item.hidden = index >= visibleCount;
      item.classList.remove('is-mobile-revealing');
    });

    if (loadMore) {
      loadMore.hidden = visibleCount >= items.length;
    }
  }

  function renderHeaderProductCarousel(carousel) {
    const items = Array.from(carousel.querySelectorAll('[data-carousel-item]'));
    const pageSize = parseInt(carousel.getAttribute('data-page-size'), 10) || 6;
    const totalPages = Math.ceil(items.length / pageSize);
    const prev = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    const dots = carousel.querySelector('[data-carousel-dots]');
    let page = parseInt(carousel.dataset.page || '0', 10);

    if (Number.isNaN(page)) page = 0;
    page = Math.max(0, Math.min(page, Math.max(totalPages - 1, 0)));
    carousel.dataset.page = String(page);

    items.forEach((item, index) => {
      const visible = index >= page * pageSize && index < (page + 1) * pageSize;
      item.hidden = !visible;
    });

    if (prev) prev.disabled = page === 0;
    if (next) next.disabled = page >= totalPages - 1;
    if (dots) {
      dots.querySelectorAll('[data-carousel-dot]').forEach((dot, index) => {
        dot.setAttribute('aria-current', index === page ? 'true' : 'false');
      });
    }
  }

  document.addEventListener('click', function (event) {
    const loadMoreButton = event.target.closest('[data-carousel-load-more]');
    if (loadMoreButton) {
      const carousel = loadMoreButton.closest('[data-header-product-carousel]');
      if (!carousel || window.matchMedia('(min-width: 990px)').matches) return;

      event.preventDefault();
      event.stopPropagation();

      const items = Array.from(carousel.querySelectorAll('[data-carousel-item]'));
      const currentVisible = parseInt(carousel.dataset.mobileVisible || '3', 10);
      const safeCurrentVisible = Number.isNaN(currentVisible) ? 3 : currentVisible;
      const nextVisible = Math.min(safeCurrentVisible + 6, items.length);

      carousel.dataset.mobileVisible = String(nextVisible);
      initHeaderProductMobileLoadMore(carousel, items);

      items.slice(safeCurrentVisible, nextVisible).forEach((item, index) => {
        item.classList.add('is-mobile-revealing');
        item.style.setProperty('--mobile-reveal-index', String(index));
        item.addEventListener('animationend', () => {
          item.classList.remove('is-mobile-revealing');
          item.style.removeProperty('--mobile-reveal-index');
        }, { once: true });
      });
      return;
    }

    const carouselButton = event.target.closest('[data-carousel-prev], [data-carousel-next], [data-carousel-dot]');
    if (!carouselButton) return;

    const carousel = carouselButton.closest('[data-header-product-carousel]');
    if (!carousel || !window.matchMedia('(min-width: 990px)').matches) return;

    event.preventDefault();
    event.stopPropagation();

    const items = Array.from(carousel.querySelectorAll('[data-carousel-item]'));
    const pageSize = parseInt(carousel.getAttribute('data-page-size'), 10) || 6;
    const totalPages = Math.ceil(items.length / pageSize);
    let page = parseInt(carousel.dataset.page || '0', 10);

    if (Number.isNaN(page)) page = 0;

    if (totalPages <= 1) return;

    const previousPage = page;

    if (carouselButton.matches('[data-carousel-prev]')) {
      page = page <= 0 ? totalPages - 1 : page - 1;
    } else if (carouselButton.matches('[data-carousel-next]')) {
      page = page >= totalPages - 1 ? 0 : page + 1;
    } else if (carouselButton.matches('[data-carousel-dot]')) {
      page = parseInt(carouselButton.getAttribute('data-carousel-page'), 10);
    }

    page = Math.max(0, Math.min(page, totalPages - 1));
    if (page === previousPage) return;

    const direction = page > previousPage || (previousPage === totalPages - 1 && page === 0) ? 1 : -1;
    carousel.style.setProperty('--carousel-shift', (direction * -8) + 'px');
    carousel.classList.add('is-transitioning');

    window.setTimeout(() => {
      carousel.dataset.page = String(page);
      carousel.style.setProperty('--carousel-shift', (direction * 8) + 'px');
      renderHeaderProductCarousel(carousel);
      window.requestAnimationFrame(() => {
        carousel.classList.remove('is-transitioning');
      });
    }, 180);
  }, true);

  initHeaderProductCarousels();
  document.addEventListener('DOMContentLoaded', initHeaderProductCarousels);
  document.addEventListener('shopify:section:load', initHeaderProductCarousels);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.site-header__nav-item.has-dropdown[data-open="true"]').forEach((el) => {
      el.removeAttribute('data-open');
      const btn = el.querySelector('.site-header__nav-toggle');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
    if (menuToggle && menuToggle.getAttribute('aria-expanded') === 'true') {
      setMobileMenu(false);
    }
  });
})();
document.addEventListener('DOMContentLoaded', function () {
  const galleries = document.querySelectorAll('media-gallery, .product__media-gallery, .product-gallery');

  galleries.forEach(function (gallery) {
    const thumbnails = gallery.querySelectorAll(
      '.thumbnail-list button, .thumbnail-list__item button, .thumbnail, [data-media-id], [data-target]'
    );

    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function (event) {
        const clicked = event.currentTarget;

        const mediaId =
          clicked.getAttribute('data-target') ||
          clicked.getAttribute('data-media-id') ||
          clicked.closest('[data-media-id]')?.getAttribute('data-media-id');

        if (!mediaId) return;

        const mediaItems = gallery.querySelectorAll(
          '.product__media-item, .product-media-item, [data-media-id]'
        );

        mediaItems.forEach(function (item) {
          const itemMediaId = item.getAttribute('data-media-id');

          if (itemMediaId === mediaId || item.id === mediaId || item.id.includes(mediaId)) {
            item.classList.add('is-active');
            item.removeAttribute('hidden');
            item.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'nearest'
            });
          } else {
            item.classList.remove('is-active');
          }
        });

        thumbnails.forEach(function (t) {
          t.classList.remove('is-active');
          t.removeAttribute('aria-current');
        });

        clicked.classList.add('is-active');
        clicked.setAttribute('aria-current', 'true');
      });
    });
  });
});